module.exports = __webpack_public_path__ + "img/jituan_zhizhao.20db9f41.jpg";